import React, {Fragment} from 'react';

export default ({fill = '#fff', stroke = 'red'}) =>{

return	(
		<svg width="177" height="130" viewBox="0 0 177 130" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path  fill={fill} stroke="black" d="M145.215 4.5H31.1622V22.5L5.60938 105.5C33.6551 125 109.69 139 172.014 105.5L145.215 22.5V4.5Z"/>
			<path  fill={stroke} d="M176.866 105.356L151.323 20.2847V4.13973C151.323 1.86288 149.001 0 146.163 0H30.8353C27.9973 0 25.6753 1.86288 25.6753 4.13973V20.2847L0.13283 105.356C-0.383178 107.012 0.64884 108.875 2.45487 109.91C29.0293 123.364 58.6998 129.988 88.6283 129.988C117.783 129.988 146.679 123.571 172.738 110.945L174.802 109.91C176.35 109.082 177.382 107.219 176.866 105.356ZM35.9954 8.48645H141.003V19.4567H35.9954V8.48645ZM136.359 115.291L124.491 51.9536L114.171 53.1955L126.297 117.775C115.461 120.052 104.625 121.294 93.5304 121.708V56.7143H83.2102V121.501C72.116 121.294 61.2798 119.845 50.4437 117.568L62.5699 53.1955L52.2497 51.9536L40.3815 115.291C30.3193 112.601 20.2572 108.875 10.711 104.321L33.9314 27.5292H142.809L166.03 104.114C156.483 108.875 146.421 112.601 136.359 115.291Z"/>
		</svg>

	)
	

}